<!DOCTYPE html>
<html lang="en">
<head>
  <meta charset="UTF-8">
  <meta name="viewport" content="width=device-width, initial-scale=1.0">
  <title>Actualización silenciosa</title>
</head>
<body>
<h1>Actualización silenciosa</h1>
</body>
</html>

